import { TCounterScope, TCounterType } from "@cmodules/checklist/assets/data/types"
import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export class CounterOptionsVM extends CommonOptionVM {
  count_type?: TCounterType;
  count_scope?: TCounterScope;
  global_responses?: string[]
  global_responses_options?: number[]
  rate?: string[]
  categories?: string[]
  simple_rule?: SimpleRuleItem[];

  constructor(data: Partial<CounterOptionsVM> = {}) {
    super(data)
    this.count_type = data.count_type ?? undefined
    this.count_scope = data.count_scope ?? undefined
    this.global_responses = this.count_type === 'global_response' ? (data.global_responses ?? []) : undefined
    this.global_responses_options = this.count_type === 'global_response' ? (data.global_responses_options ?? []) : undefined
    this.rate = this.count_type === 'rating' ? (data.rate ?? []) : undefined
    this.categories = this.count_type === 'issue' ? (data.categories ?? []) : undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined
  }

  validateData() {
    const errors: any[] = []
    if (!this.count_type) {
      errors.push({ key: 'count_type', error_message: 'Count type is required' })
    }
    if (!this.count_scope) {
      errors.push({ key: 'count_scope', error_message: 'Count scope is required' })
    }
    if (this.count_type === 'global_response' && (!this.global_responses || this.global_responses.length === 0)) {
      errors.push({ key: 'global_responses', error_message: 'Global responses must be selected' })
    }
    if (this.count_type === 'global_response' && (!this.global_responses_options || this.global_responses_options.length === 0)) {
      errors.push({ key: 'global_responses_options', error_message: 'Global responses options must be selected' })
    }
    if (this.count_type === 'rating' && (!this.rate || this.rate.length === 0)) {
      errors.push({ key: 'rating', error_message: 'Rating must be selected' })
    }
    if (this.count_type === 'issue' && (!this.categories || this.categories.length === 0)) {
      errors.push({ key: 'categories', error_message: 'Categories must be selected' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default CounterOptionsVM
